<naas-alerts id="main_content"></naas-alerts>
<naas-school-banner></naas-school-banner>
<naas-container-selector></naas-container-selector>
